'use strict';

// Corresponds to the page version v14
const USER_AGENTS = {
  ios: [
    '86dc05cd-efe3-4d42-b5ee-4bf09f842e82', // iOS UK Sportsbook app
    '5bf325ba-c357-4ad4-966c-838f50fb9780', // iOS iPad UK Sportsbook app
    '0bb33ea0-e58d-4fe8-8a25-4a683b6ef819', // iOS Int App
    '3947a74c-aaff-455b-8034-7e2c3a79e28f', // iOS iPad Int app
    'bea752e4-8847-4ed9-8853-82bd27e0bc58', // iOS iPad Spain
    '9662680a-9980-4098-a0a6-ff4b3992feee', // iOS iPad Italy
    'b88d9586-dcb7-4218-848c-94f9d518961d', // iOS iPhone Spain
    '6c726972-026e-420c-a743-53c8649101bf', // iOS iPhone Italy
    '82705eab-511b-4264-991d-22d33fabc7d4', // iOS - Ireland Sportsbook
    '41bfacee-da4c-4e61-a086-90d05518f7b4', // iOS iPad Sportsbook Ireland
    '01919319-cd67-7ddd-a23a-b38b6834a842', // iOS UK Vegas
    '5eaaadc3-3145-4490-a4d8-db9bdf9d4182', // Spain Hybrid 888 App
  ],
  android: [
    '578b7a00-b3e0-4988-8e61-5feec3840c7c', // Android UK app (Sbk)
    'd6596ce2-c402-4efa-950b-90c3646767ec', // Android Spain
    'd0f50d28-5faf-465b-a398-e29d6f98cf7a', // Android Italy
    'f141b425-3de3-41f7-89b1-b2f697ecc3f8', // Android (standalone) Int App
    '550a9637-9be4-4dee-9376-7d5c45929376', // Google Play Int App
    '1ed296b0-a4eb-4df4-9e1b-6de49ac721fa', // Huawei Int App
    'a961ce80-c24c-4b99-aa3e-07bcb78941d8', // Android Casino Italy
    'e932bg67-7bz7-46d2-76c3-cK5J82bdd2a9', // Vegas Spain App
    '94492a82-8455-4746-89db-9437fb3546f9', // Android Vegas Casino UK
    '3d91a5c5-da62-4b04-af8d-9bb3d4d3d3d8', // Android Sportsbook Ireland
  ],
};

const isIosApp = (userAgent) => USER_AGENTS.ios.some((x) => userAgent.includes(x));
const isAndroidApp = (userAgent) => USER_AGENTS.android.some((x) => userAgent.includes(x));
const isNativeApp = (userAgent) => isIosApp(userAgent) || isAndroidApp(userAgent);

module.exports = { isIosApp, isAndroidApp, isNativeApp };
